import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaWpforms } from 'react-icons/fa';
import { userAppData } from '../MainApp.js';
import { getActiveFormSteps } from '../forms/formsUserApi.js';
import './DashboardFormSteps.css';

/** Show a forms notification or the empty state, refreshing on dashboard entry. */
export default function DashboardFormSteps() {
  const navigate = useNavigate();
  const authorised = Number(userAppData.formsData?.perms ?? 0) === 1;
  const callerId = userAppData.cogId;
  const [count, setCount] = useState(() => new Set(
    Array.isArray(userAppData.formsData?.activeSteps) ? userAppData.formsData.activeSteps : [],
  ).size);
  const [refreshFailed, setRefreshFailed] = useState(false);

  useEffect(() => {
    if (!authorised) return undefined;
    let cancelled = false;
    setRefreshFailed(false);
    getActiveFormSteps().then((steps) => {
      if (cancelled) return;
      const ids = [...new Set(steps.map((step) => step.submissionId))];
      setCount(ids.length);
      userAppData.formsData.activeSteps = ids;
      userAppData.formsData.activeStepRecords = steps.map(({ submissionId, formId, submittedAt }) => ({ submissionId, formId, submittedAt }));
    }).catch(() => {
      // Keep the login count and offer the inbox when its refresh is unavailable.
      if (!cancelled) setRefreshFailed(true);
    });
    return () => { cancelled = true; };
  }, [authorised, callerId]);

  if (!authorised || (count === 0 && !refreshFailed)) {
    return <p className='dashboardNotifications_emptyState'>No new notifications</p>;
  }

  // Keep the full message available when a narrow notification row truncates it.
  const message = count > 0
    ? `${count} ${count === 1 ? 'form awaits' : 'forms await'} your input${refreshFailed ? ' (count unavailable to refresh)' : ''}`
    : 'Check waiting forms (count unavailable)';

  return <section className='dashboard-form-steps' aria-label='Forms awaiting your attention'>
    {/* Match the Forms module icon used in the sidebar. */}
    <FaWpforms className='dashboard-form-steps-icon' aria-hidden='true' />
    <p className='dashboard-form-steps-message' aria-live='polite' title={message}>{message}</p>
    <button type='button' aria-label={`View waiting forms: ${message}`} title='View waiting forms' onClick={() => navigate('/app/forms/steps')}>
      <FaArrowRight aria-hidden='true' />
    </button>
  </section>;
}
